import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ADD_FORM_NAME } from 'presentations/constants';
import AddStepRevisions from 'presentations/components/add_step_revisions';

const mapStateToProps = (state) => {
  const selector = formValueSelector(ADD_FORM_NAME);
  const selected = selector(state, 'selected_revisions');
  return {
    selected
  };
}

export default connect(mapStateToProps)(AddStepRevisions);



// WEBPACK FOOTER //
// ./presentations/containers/add_step_revisions.js